import { createFileRoute, redirect } from '@tanstack/react-router'
import { bookedSalesSearchSchema } from '@/lib/services/money/money.schema'

// Sales Summary moved to /reports/sales-summary; keep older links working.
export const Route = createFileRoute('/_authenticated/$orgId/reports/sales/$date')({
  validateSearch: (search) => bookedSalesSearchSchema.parse(search),
  beforeLoad: ({ params, search }) => {
    throw redirect({ to: '/$orgId/reports/sales-summary/$date', params, search, replace: true })
  },
})
